module.exports = __webpack_public_path__ + "img/result_sign_true.249afbfe.png";